import React from "react";
import { Card } from "reactstrap";
import { Link } from "react-router-dom";

import { numberSeparate } from "../../utils";

const DataCard = ({ title, amount, chart: ChartComponent, url }) => {
  return (
    <Card>
      <div className="nk-ecwg nk-ecwg6">
        <div className="card-inner">
          <div className="card-title-group">
            <div className="card-title">
              <Link to={url} className="h6 title fw-normal">
                {title}
              </Link>
            </div>
          </div>
          <div className="data">
            <div className="data-group">
              <div className="amount">{numberSeparate(amount)}</div>
              <div className="nk-ecwg6-ck">{ChartComponent}</div>
            </div>
          </div>
        </div>
      </div>
    </Card>
  );
};

export default DataCard;
